export default __webpack_public_path__ + "static/media/premium-member-star.5790622e.png";